import { render, staticRenderFns } from "./AddTagsToVideoModal.vue?vue&type=template&id=5462375a&scoped=true&"
import script from "./AddTagsToVideoModal.vue?vue&type=script&lang=js&"
export * from "./AddTagsToVideoModal.vue?vue&type=script&lang=js&"
import style0 from "./AddTagsToVideoModal.vue?vue&type=style&index=0&id=5462375a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5462375a",
  null
  
)

export default component.exports